import { Button, FormControl, TextField, MenuItem, Dialog, DialogTitle, DialogContent, DialogActions, Box, Card, Typography, CardContent, Grid, FormControlLabel, Checkbox } from '@mui/material';
import { useCallback, useState } from 'react';
import { timezones } from './timezones';
import validator from './validator';
import { useEffect } from 'react';

const initialProject = { name: '', timezoneOffset: '00:00:00' };

export function ProjectEditor({ isOpen, onClose, onSave, initProject, sports }) {
  const [project, setProject] = useState(initProject || initialProject);
  const [sportsHash, setSprotsHash] = useState({});
  const [errors, setErrors] = useState({});

  const handleSave = useCallback(async () => {
    try {
      const errors = validator.validate(project);
      setErrors(errors);
      if (Object.keys(errors).length > 0) {
        return;
      }
      const newSports = []
      sports.forEach((sport) => {
        if (!sportsHash[sport.name].isChecked) {
          return;
        }
        const sources = sport.sources.filter((source) => sportsHash[sport.name].sources[source].isChecked) || [];
        newSports.push({ sport: sport.name, sources });
      });
      onSave({ ...project, configuration: { sports: newSports } });
    } catch (e) { }
  }, [project, onSave, sports, sportsHash]);

  const onChange = useCallback((event) => {
    const { name, value } = event.target
    const newErrors = { ...errors };
    delete newErrors[name];
    setErrors(newErrors);
    setProject(prev => ({
      ...prev,
      [name]: value
    }));
  }, [errors]);

  const handleSportChange = useCallback((e) => {
    const { name, checked } = e.target;
    setSprotsHash(prev => {
      if (!checked) {
        const sources = Object.fromEntries(
          Object.entries(prev[name].sources).map(([key, value]) => [
            key,
            { ...value, isChecked: false }
          ])
        );
        return { ...prev, [name]: { name, sources, isChecked: checked } };
      }
      return { ...prev, [name]: { ...prev[name], isChecked: checked } };
    });
  }, []);

  const handleSourceChange = useCallback((e, sportName) => {
    const { name, checked } = e.target;
    setSprotsHash(prev => {
      return { ...prev, [sportName]: { ...prev[sportName], sources: { ...prev[sportName].sources, [name]: { ...prev[sportName].sources[name], isChecked: checked } } } };
    });
  }, []);

  useEffect(() => {
    if (!sports) {
      return;
    }
    const sportsHash = sports.reduce((a, c) => {
      a[c.name] = { name: c.name, isChecked: false, sources: {} };
      c.sources.forEach((item) => {
        a[c.name].sources[item] = { name: item, isChecked: false };
      });
      return a;
    }, {});
    if (!initProject) {
      return setSprotsHash(sportsHash);
    }
    initProject.configuration.sports.forEach((item) => {
      sportsHash[item.sport].isChecked = true;
      item.sources.forEach((source) => {
        sportsHash[item.sport].sources[source].isChecked = true;
      })
    });
    setSprotsHash(sportsHash);
  }, [sports, initProject]);

  console.log(project);


  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
    >
      <DialogTitle>
        {project.id ? 'Edit project' : 'New project'}
      </DialogTitle>
      <DialogContent>
        <Box style={{ paddingTop: 10, display: 'flex', flexDirection: 'column', gap: '30px' }}>
          <TextField
            sx={{ width: '100%' }}
            name="name"
            label="Name"
            value={project.name}
            variant="outlined"
            size="small"
            onChange={onChange}
            error={errors?.name}
            helperText={errors?.name}
          />

          <FormControl style={{ textAlign: 'left' }} sx={{ width: '100%' }}>
            <TextField
              select
              value={project.timezoneOffset}
              label="Timezone Offset"
              name="timezoneOffset"
              variant="outlined"
              size="small"
              onChange={onChange}
              helperText={errors?.timezoneOffset}
            >
              {timezones.map((item, index) => (
                <MenuItem key={index} value={item}>
                  {item}
                </MenuItem>
              ))}
            </TextField>
          </FormControl>
          <Grid container spacing={2}>
            {Object.values(sportsHash).map((sport, sportIndex) =>
              <Grid key={sportIndex} item xs={12} md={6}>
                <Card variant="outlined" sx={{ width: '100%' }}>
                  <CardContent>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <Typography variant='subtitle1' fontWeight={600} sx={{ alignSelf: 'center' }}>{sport.name}</Typography>
                      <FormControlLabel
                        control={<Checkbox
                          name={sport.name}
                          value={sport.name}
                          checked={sport.isChecked}
                          onChange={handleSportChange}
                        />}
                      />
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px', padding: '8px' }}>
                      {Object.values(sport.sources).map((source, index) =>
                        <FormControlLabel
                          key={index}
                          control={<Checkbox
                            name={source.name}
                            value={source.name}
                            checked={source.isChecked}
                            disabled={!sport.isChecked}
                            onChange={(e) => handleSourceChange(e, sport.name)}
                          />}
                          label={source.name} />
                      )}
                    </Box>
                  </CardContent>
                </Card>
              </Grid>)}
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button color="primary" variant="contained" onClick={handleSave}>{project.id ? 'Edit' : 'Create'}</Button>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}
